// components/SaveDestinationDialog.js — выбор способа сохранения .ptCAD

import React from 'react';
import { Dialog, Box, Typography, IconButton } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';

export default function SaveDestinationDialog({ open, onClose, onSelectDevice, onSelectCloud, isLoggedIn }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '0.75rem',
          overflow: 'hidden',
          boxShadow: '0 1.5rem 4rem rgba(0,0,0,0.15)',
        }
      }}
    >
      {/* Шапка */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, borderBottom: '0.0625rem solid #f0f0f0' }}>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#212121', lineHeight: 1.2 }}>
            Сохранить чертёж
          </Typography>
          <Typography sx={{ fontSize: '0.72rem', color: '#9e9e9e', mt: 0.25 }}>
            Выберите способ сохранения
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: '#9e9e9e', '&:hover': { color: '#212121', background: '#f5f5f5' } }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Карточки выбора */}
      <Box sx={{ display: 'flex', gap: 1.5, p: 2.5 }}>
        {/* На устройство */}
        <Box
          onClick={onSelectDevice}
          sx={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25,
            p: 2.5, borderRadius: '0.6rem', cursor: 'pointer',
            border: '0.125rem solid #e8e8e8',
            background: '#fafafa',
            transition: 'all 0.15s',
            '&:hover': {
              border: '0.125rem solid #d32f2f',
              background: '#fff5f5',
              boxShadow: '0 0.25rem 1rem rgba(211,47,47,0.1)',
              transform: 'translateY(-0.1rem)',
            },
          }}
        >
          <Box sx={{
            width: '3rem', height: '3rem', borderRadius: '0.75rem',
            background: 'linear-gradient(135deg, #e8e8e8, #f5f5f5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <ComputerIcon sx={{ fontSize: '1.6rem', color: '#616161' }} />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#212121', mb: 0.4 }}>
              На устройство
            </Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#616161', lineHeight: 1.45 }}>
              Сохранить файл .ptCAD локально на компьютер
            </Typography>
          </Box>
        </Box>

        {/* В облако */}
        <Box
          onClick={isLoggedIn ? onSelectCloud : undefined}
          sx={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25,
            p: 2.5, borderRadius: '0.6rem',
            border: '0.125rem solid #e8e8e8',
            background: '#fafafa',
            cursor: isLoggedIn ? 'pointer' : 'not-allowed',
            opacity: isLoggedIn ? 1 : 0.5,
            transition: 'all 0.15s',
            ...(isLoggedIn ? {
              '&:hover': {
                border: '0.125rem solid #1565c0',
                background: '#f0f4ff',
                boxShadow: '0 0.25rem 1rem rgba(21,101,192,0.1)',
                transform: 'translateY(-0.1rem)',
              },
            } : {}),
          }}
        >
          <Box sx={{
            width: '3rem', height: '3rem', borderRadius: '0.75rem',
            background: isLoggedIn
              ? 'linear-gradient(135deg, #1565c0, #1976d2)'
              : 'linear-gradient(135deg, #e0e0e0, #eeeeee)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <CloudUploadIcon sx={{ fontSize: '1.6rem', color: isLoggedIn ? '#fff' : '#9e9e9e' }} />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#212121', mb: 0.4 }}>
              В облако
            </Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#616161', lineHeight: 1.45 }}>
              {isLoggedIn
                ? 'Сохранение в облаке и в списке «История чертежей»'
                : 'Необходима авторизация'}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Подсказка */}
      <Box sx={{ px: 2.5, pb: 2.5 }}>
        <Box
          sx={{
            p: 1.75,
            borderRadius: '0.5rem',
            background: isLoggedIn ? '#e8f0fe' : '#f5f5f5',
            border: `0.0625rem solid ${isLoggedIn ? '#90caf9' : '#e0e0e0'}`,
          }}
        >
          <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: isLoggedIn ? '#0d47a1' : '#424242', mb: 0.75 }}>
            {isLoggedIn ? 'Где найти сохранённый чертёж?' : 'Нужен аккаунт'}
          </Typography>
          <Typography sx={{ fontSize: '0.8rem', color: '#212121', lineHeight: 1.55 }}>
            {isLoggedIn ? (
              <>
                На <Box component="span" sx={{ fontWeight: 600 }}>главной странице</Box> нажмите на свой{' '}
                <Box component="span" sx={{ fontWeight: 600 }}>аккаунт (email) справа вверху</Box>
                {' '}и выберите{' '}
                <Box component="span" sx={{ fontWeight: 600 }}>«История чертежей»</Box>.
              </>
            ) : (
              'Войдите в аккаунт, чтобы сохранять чертежи в облако и открывать их из истории на главной странице.'
            )}
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
}
